import axios from "axios";
import { envVariables } from "../config/global.config";
import { axiosDelete, axiosGet, axiosPatch, axiosPost } from "./api.gateway";

export const fetchAllUsers = async () => {
  try {
    const response = await axiosGet('/user');
    return response;
  } catch (error) {
    throw error;
  }
}

export const fetchUserByUUID = async (uuid) => {
  try {
    const response = await axiosGet(`${envVariables.API_URL}/api/user/${uuid}`);
    if (!response) {
      throw new Error('An error occurred');
    }
    return response;
  } catch (error) {
    throw error;
  }
}

export const createUser = async (data) => {
  try {
    const response = await axiosPost(`${envVariables.API_URL}/api/user/create`, data);
    if (!response) {
      throw new Error('An error occurred');
    }
    return response;
  } catch (error) {
    throw error;
  }
}

export const updateUser = async (uuid, data) => {
  try {
    const response = await axiosPatch(`${envVariables.API_URL}/api/user/edit/${uuid}`, data);
    if (!response) {
      throw new Error('An error occurred');
    }
    return response;
  } catch (error) {
    throw error;
  }
}

export const deleteUser = async (uuid) => {
  try {
    const response = await axiosDelete(`${envVariables.API_URL}/api/user/delete/${uuid}`);
    if (!response) {
      throw new Error('An error occurred');
    }
    return response;
  } catch (error) {
    throw error;
  }
};

export const changeUserPassword = async (uuid, newPassword) => {
  try {
    const response = await axiosPatch(`${envVariables.API_URL}/api/user/changePassword/${uuid}`, {
      newPassword: newPassword,
    });
    if (!response) {
      throw new Error('An error occurred');
    }
    return response;
  } catch (error) {
    throw error;
  }
};
